






import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
@Component
export default class TriStateCheckBox extends Vue{
    @Prop() stateProp?: string;
    @Watch('stateProp')
    onStatePropChanged(nVal: string, oVal: string){
        this.state = nVal;
    }
    state = 'dontCare';
    changeState(){
        if(this.state === 'dontCare')
            this.state = 'checked';
        else if(this.state === 'checked')
            this.state = 'unChecked';
        else if(this.state === 'unChecked')
            this.state = 'dontCare';
        this.$emit('state-changed',this.state);
        //alert(this.state);
    }
}
